import React, {useMemo, useState} from 'react'
import {useEffect} from "react";
import {MRT_ColumnDef} from "material-react-table";
import styled from "styled-components";
import ArgosFlexbox from "../Containers/ArgosFlexbox";
import {ArgosTableSimple} from "../Table/ArgosTableSimple";
interface AdasUsageProps {
  adasUsage: any
}

export interface AdasUsageRow {
  adasProgram: string,
  modelYear: string,
  vehicleProgram: string,
  location: string,
}

const AdasUsage = (props: AdasUsageProps) => {
  const usage: any = props?.adasUsage ?? {}
  const [tableData,setTableData] = useState<any[]>([])

  const adasUsageColumns = useMemo<MRT_ColumnDef<AdasUsageRow>[]>(
    () => [
      {
        accessorKey: 'adasProgram',
        header: 'Program Name',
        size: 300,
      },
      {
        accessorKey: 'modelYear',
        header: 'Model Year',
        size: 300,
      },
      {
        accessorKey: 'location',
        header: 'Location',
        size: 300,
      },
      {
        accessorKey: 'vehicleProgram',
        header: 'Vehicle Program',
        size: 300,
      },
    ],
    []
  )
  const mapPropsToTableFormat = () => {
    let _tableData: any[] = []
    Object.keys(usage).forEach((adasIdKey: string)=> {
      const adasProgramInfo: any = usage[adasIdKey]

      const vehicleProgramInfo: any = adasProgramInfo["vehicle_programs_info"]
      const locationsInfo: any = adasProgramInfo["locations"]

      if (Object.keys(vehicleProgramInfo).length == 0){
        vehicleProgramInfo["default"] = {"vehicleProgramCode": "-"}
      }
      Object.keys(vehicleProgramInfo).forEach((vehicleProgramId: any)=> {
       if (locationsInfo.length == 0){
        locationsInfo.push({"location": "-"})
        }
       locationsInfo.forEach((location: string)=> {
          const adasProgramBaseRow: any = {
          "adasProgram": adasProgramInfo["adasProgramName"],
          "modelYear": adasProgramInfo["adasModelYear"],
          "vehicleProgram": vehicleProgramInfo?.[vehicleProgramId]["vehicleProgramCode"],
          "location": location
        }
        _tableData.push(adasProgramBaseRow)
       })
      })
    })
    setTableData(_tableData)
  }
  useEffect(() => {
    mapPropsToTableFormat()
  }, [props])
  return(
    <ArgosFlexbox vertical style={{ overflow: 'auto', height: '100%' }}>
      <ArgosTableSimple
        columns={adasUsageColumns}
        data={tableData}
        enablePagination={true}
        enableGrouping={true}

        initialState={{
          expanded: true,
          grouping: ['adasProgram'],
          density: 'compact'
        }}/>
    </ArgosFlexbox>
  )
}

export default AdasUsage